import c from './mock-users.module.scss';
import UserCard from '../user-card/UserCard';
import AvailableApplications from '../available-applications/AvailableApplications';

const MockUsers = ({
  mockUserIdentities,
  currentlyImpersonating,
  startImpersonation,
  endImpersonation,
}) => {
  if (currentlyImpersonating) {
    return (
      <div className={c.currentlyImpersonatingContainer}>
        <UserCard
          data={currentlyImpersonating}
          onEnd={endImpersonation}
          active
        />
        <AvailableApplications />
      </div>
    );
  }

  return (
    <div className={c.mockUsersContainer}>
      {mockUserIdentities?.map((identity) => {
        return (
          <UserCard
            key={identity.uid}
            data={{ ...identity, isMockUser: true }}
            onSelect={startImpersonation}
          />
        );
      })}
    </div>
  );
};

export default MockUsers;
